export default __webpack_public_path__ + "static/media/69.bbe8467b.svg";